var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('Dashboard',{attrs:{"type":_vm.type}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-item"},[_c('h1',[_vm._v("Dashboard")])])}]

export { render, staticRenderFns }